module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLight.ttf?34d539758dbf5fe691838975818bf166";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLight.ttf
// module id = 1399
// module chunks = 0